import { render, staticRenderFns } from "./AppMealCard.vue?vue&type=template&id=1253aa06&scoped=true&"
import script from "./AppMealCard.vue?vue&type=script&lang=js&"
export * from "./AppMealCard.vue?vue&type=script&lang=js&"
import style0 from "./AppMealCard.vue?vue&type=style&index=0&id=1253aa06&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1253aa06",
  null
  
)

export default component.exports